<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Rechtsanwalt"
        @save="saveLawyerFormData">
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :disabled="!permissions.canAssignLawyer"
                :form-context="formContext"
                label="Anwaltskanzlei"
                :options-loader="loadLawyerOptions"
                property="lawyer"
                type="autocomplete">
                <template v-slot:display-value>
                    <p>
                        <span v-if="firmData.name"><b>{{ firmData.name }}</b><br/></span>
                        <span v-if="firmData.street">{{ firmData.street }}<br/></span>
                        <span v-if="firmData.postalCode || firmData.city">
                        {{ firmData.postalCode }} {{ firmData.city }}<br/>
                    </span>
                        <span v-if="firmData.countryName">{{ firmData.countryName }}<br/></span>
                    </p>
                    <p>
                        <span v-if="firmData.phone">{{ firmData.phone }}<br/></span>
                        <span v-if="firmData.email">
                            <a :href="'mailto:' + firmData.email">{{ firmData.email }}</a>
                        </span>
                    </p>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                class="col-6"
                :dependencies="['lawyer']"
                :disabled="!permissions.canAssignDesiredLawyerUser"
                :form-context="formContext"
                label="Wunschanwalt"
                :options-loader="loadDesiredLawyerUserOptions"
                property="desiredLawyerUser"
                type="autocomplete">
                <template v-slot:display-value>
                    <p>
                        <span v-if="desiredLawyerUserData.name"><b>{{ desiredLawyerUserData.name }}</b><br/></span>
                        <span v-if="desiredLawyerUserData.street">{{ desiredLawyerUserData.street }}<br/></span>
                        <span v-if="desiredLawyerUserData.postalCode || desiredLawyerUserData.place">
                        {{ desiredLawyerUserData.postalCode }} {{ desiredLawyerUserData.place }}<br/>
                    </span>
                        <span v-if="desiredLawyerUserData.countryName">
                            {{ desiredLawyerUserData.countryName }}<br/>
                        </span>
                    </p>
                    <p>
                        <span v-if="desiredLawyerUserData.phone">{{ desiredLawyerUserData.phone }}<br/></span>
                        <span v-if="desiredLawyerUserData.email">
                        <a :href="'mailto:' + desiredLawyerUserData.email">{{ desiredLawyerUserData.email }}</a>
                    </span>
                    </p>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                class="col-6"
                :dependencies="['lawyer']"
                :disabled="permissions.canAssignLawyerUser === false"
                :form-context="formContext"
                label="Anwaltsbenutzer"
                :options-loader="loadLawyerUserOptions"
                property="lawyerUser"
                type="autocomplete">
                <template v-slot:display-value>
                    <p>
                        <span v-if="userData.name"><b>{{ userData.name }}</b><br/></span>
                        <span v-if="userData.street">{{ userData.street }}<br/></span>
                        <span v-if="userData.postalCode || userData.place">
                        {{ userData.postalCode }} {{ userData.place }}<br/>
                    </span>
                        <span v-if="userData.countryName">{{ userData.countryName }}<br/></span>
                    </p>
                    <p>
                        <span v-if="userData.phone">{{ userData.phone }}<br/></span>
                        <span v-if="userData.email">
                        <a :href="'mailto:' + userData.email">{{ userData.email }}</a>
                    </span>
                    </p>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
import Container from '@services/Container';
import FormDataMixin from '../../mixins/FormDataMixin';

const container = Container.getInstance();

const recordRepository = container.getDesktopRecordRepository();

export default {
    name: 'ParticipantLawyer',
    mixins: [FormDataMixin],
    computed: {
        recordId() {
            return this.$route.params.recordId;
        },
        desiredLawyerUserData() {
            return {
                'name': this.formContext.form.getProperty('desiredLawyerUserName') ?? '',
                'street': this.formContext.form.getProperty('desiredLawyerUserStreet') ?? '',
                'postalCode': this.formContext.form.getProperty('desiredLawyerUserPostalCode') ?? '',
                'place': this.formContext.form.getProperty('desiredLawyerUserPlace') ?? '',
                'countryName': this.formContext.form.getProperty('desiredLawyerUserCountryName') ?? '',
                'phone': this.formContext.form.getProperty('desiredLawyerUserPhone') ?? '',
                'email': this.formContext.form.getProperty('desiredLawyerUserEmail') ?? '',
            };
        },
        userData() {
            return {
                'name': this.formContext.form.getProperty('userName') ?? '',
                'street': this.formContext.form.getProperty('userStreet') ?? '',
                'postalCode': this.formContext.form.getProperty('userPostalCode') ?? '',
                'place': this.formContext.form.getProperty('userPlace') ?? '',
                'countryName': this.formContext.form.getProperty('userCountryName') ?? '',
                'phone': this.formContext.form.getProperty('userPhone') ?? '',
                'email': this.formContext.form.getProperty('userEmail') ?? '',
            };
        },
        firmData() {
            return {
                'name': this.formContext.form.getProperty('firmName') ?? '',
                'street': this.formContext.form.getProperty('firmStreet') ?? '',
                'postalCode': this.formContext.form.getProperty('firmPostalCode') ?? '',
                'city': this.formContext.form.getProperty('firmCity') ?? '',
                'countryName': this.formContext.form.getProperty('firmCountryName') ?? '',
                'phone': this.formContext.form.getProperty('firmPhone') ?? '',
                'email': this.formContext.form.getProperty('firmEmail') ?? '',
            };
        },
        permissions() {
            return this.formContext.permissions;
        },
    },
    methods: {
        loadDesiredLawyerUserOptions() {
            return recordRepository.loadDesiredLawyerUserOptions(this.recordId);
        },
        loadLawyerOptions() {
            return recordRepository.loadLawyerFirmOptions(this.recordId);
        },
        loadLawyerUserOptions() {
            const lawyerFirmId = this.formContext.form.getProperty('lawyer');
            return recordRepository.loadLawyerUserOptions(this.recordId, lawyerFirmId);
        },
        saveLawyerFormData(formContext) {
            const saveFunction = (objectId, postData) => {
                return recordRepository.saveParticipantsLawyer(this.recordId, postData)
            }
            this.saveFormData(formContext, saveFunction, null);
        },
    },
}
</script>
